import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_FOOD_MOOD_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateFoodMoodSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_FOOD_MOOD_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateFoodMoodSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.foodMoods.foodMood,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_FOOD_MOOD_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateFoodMoodSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_FOOD_MOOD_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateFoodMoodSimpleDetailsMutation
